import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

export const PlateTypeErrorModalBody = () => {
  return (
    <div
      id="platetypeerrormodalbody-wrapper"
      data-testid="platetypeerrormodalbody-wrapper"
    >
      <div
        id="platetypeerrormodalbody-alert"
        data-testid="platetypeerrormodalbody-alert"
        className="flex flex-row gap-5 bg-[#fff0f0] border-solid border-[1px] border-l-4 border-[#FF5252] py-3 px-5 mb-3"
      >
        <RMSvgIcon
          id="platetypeerrormodalbody-icon"
          data-testid="platetypeerrormodalbody-icon"
          name="Error"
          fill="#FF5252"
          className=""
        />
        <div
          id="platetypeerrormodalbody-alerttext"
          data-testid="platetypeerrormodalbody-alerttext"
        >
          Unable to change plate type.
        </div>
      </div>
      <span
        id="platetypeerrormodalbody-description"
        data-testid="platetypeerrormodalbody-description"
        className="text-[#5D5D5D]"
      >
        The plate type of an ISO experiment must match the plate type of the original
        experiment.
      </span>
    </div>
  );
};
